<template>
  <Modal
    v-model="relatedLogisticsModal"
    width="1100"
    :title="$t('key1005228')"
    :transfer="false"
    :mask-closable="false"
    @on-visible-change="relatedLogisticsModalChange">
    <p class="title_box">
      <span class="title">{{ $t('key1000122') }}</span>
      <span class="name" :title="logisticsChannelName">{{ logisticsChannelName }}</span>
    </p>
    <div class="flex">
      <Cascader
        style="width: 400px;"
        v-model="shippingMethodModel"
        :load-data="loadData"
        @on-change="changeShippingMethod"
        @on-visible-change="(value)=> showShippingData(value, true, 0, null, 0)"
        :data="shippingMethodData"
        filterable
        change-on-select>
      </Cascader>
      <Button class="ml10" type="primary" @click="addAssociationsBtn">{{ $t('key1005229') }}</Button>
    </div>
    <Table
      highlight-row
      border
      :loading="tableLoading"
      class="mt10"
      max-height="510"
      :columns="tableColumns"
      :data="tableData">
    </Table>
    <template #footer>
      <Button type="primary" @click="relatedLogisticsBtn">{{ $t('key1000555') }}</Button>
      <Button @click="relatedLogisticsModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {_handleMultilingualFields, getQueryCarrierShippingName, setConfigCharacters} from "@/utils/common";

export default {
  name: 'relationLogistics',
  mixins: [Mixin],
  props: {
    merchantType: {
      type: String,
      default: '2'
    }
  },
  data() {
    let v = this;
    return {
      relatedLogisticsModal: false,
      logisticsChannelName: '',
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002818'),
          key: 'name',
          align: 'center',
          minWidth: 220,
          render(h, parmas) {
            let carrierName =  _handleMultilingualFields(parmas.row.carrierName);
            let carrierShippingMethodName = _handleMultilingualFields(parmas.row.carrierShippingMethodName);
            let name = carrierName + ' / ' + carrierShippingMethodName;
            return h('div', name);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000409'),
          key: 'carrierShippingMethodCode',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005212'),
          minWidth: 160,
          key: 'logisticsInterface',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000410'),
          key: 'times',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let minEfficiency = params.row.minEfficiency;
            let maxEfficiency = params.row.maxEfficiency;
            let text = '';
            if (minEfficiency < maxEfficiency) {
              text = minEfficiency + ' - ' + maxEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000411');
            } else {
              text = maxEfficiency + ' - ' + minEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000411');
            }
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.hasTrackingNumber) {
              return h('div', 'Y');
            } else {
              return h('div', 'N');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          align: 'center',
          minWidth: 100,
          key: 'status',
          render: (h, params) => {
            let text = params.row.status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'name',
          align: 'center',
          minWidth: 110,
          render(h, params) {
            return h('Poptip', {
              props: {
                confirm: true,
                transfer: true,
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005223')
              },
              on: {
                'on-ok'() {
                  v.tableData.splice(params.index, 1);
                }
              }
            }, [
              h('optsButtonList', {
                props: {
                  operationList: [
                    {
                      text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005224'),
                      show: true,
                      clickFn: () => {

                      }
                    }
                  ]
                }
              })
            ]);
          }
        }
      ],
      tableData: [],
      carrierId: null,
      shippingMethodId: null,
      addItems: {},
      ymsLogisServiceId: null,
    };
  },
  methods: {
    // 获取列表数据
    getRelatedLogisticsList(name, ymsLogisServiceId) {
      let v = this;
      v.tableLoading = true;
      v.ymsLogisServiceId = ymsLogisServiceId;
      v.tableData = [];
      v.axios.get(api.get_ymsLogisServiceMapping + ymsLogisServiceId, {loading: true}).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          v.relatedLogisticsModal = true;
          v.logisticsChannelName = name;
          let data = response.data.datas;
          let carrierShippingMethodIdList = [];
          data.map((item) => {
            carrierShippingMethodIdList.push(item.shippingMethodId);
          });
          const getAllShippingMethods = new Promise((resolve) => {
            if (carrierShippingMethodIdList.length > 0) {
              let url = api.get_carrierShippingMethod_queryByIds + '?carrierShippingMethodIdList=' + carrierShippingMethodIdList;
              v.axios.get(url).then(res => {
                if (res.data.code === 0) {
                  let datas = res.data.datas || [];
                  if (datas.length > 0) {
                    resolve(datas);
                  }
                }
              });
            }
          });
          const getAllcarriers = getQueryCarrierShippingName(carrierShippingMethodIdList);
          Promise.all([getAllcarriers, getAllShippingMethods]).then(result => {
            if (result) {
              let shippingMethodsList = result[1];
              let carriersList = result[0];
              shippingMethodsList.map((item) => {
                carriersList.map((ele) => {
                  if (ele.carrierId === item.carrierId && ele.shippingMethodId === item.shippingMethodId) {
                    v.tableData.push({
                      carrierId: item.carrierId,
                      shippingMethodId: item.shippingMethodId,
                      carrierName: ele.carrierName,
                      carrierShippingMethodName: item.carrierShippingMethodName,
                      carrierShippingMethodCode: item.carrierShippingMethodCode,
                      logisticsInterface: item.logisticsInterface,
                      maxEfficiency: item.maxEfficiency,
                      minEfficiency: item.minEfficiency,
                      status: item.status,
                      hasTrackingNumber: item.hasTrackingNumber,
                    });
                    v.$forceUpdate();
                  }
                });
              });
            } else {
              v.tableData = [];
            }
          });
        }
      });
    },
    // 选择关联物流
    changeShippingMethod(value, data) {
      let v = this;
      v.addItems = {};
      let carrierId = null;
      let shippingMethodId = null;
      if (value.length === 0) {
        carrierId = null;
        shippingMethodId = null;
      } else if (value.length === 1) {
        carrierId = value[0];
        shippingMethodId = null;
      } else if (value.length === 2) {
        carrierId = value[0];
        shippingMethodId = value[1][0];
      }
      if (v.carrierList.length > 0) {
        v.carrierList.map((ele) => {
          if (ele.carrierId === carrierId) {
            v.addItems.carrierName = ele.carrierName;
          }
        });
        if (v.shippingMethodsList.length > 0) {
          v.shippingMethodsList.map((item) => {
            if (item.shippingMethodId === shippingMethodId) {
              v.addItems.carrierId = carrierId;
              v.addItems.shippingMethodId = shippingMethodId;
              v.addItems.carrierShippingMethodName = item.carrierShippingMethodName;
              v.addItems.carrierShippingMethodCode = item.carrierShippingMethodCode;
              v.addItems.logisticsInterface = item.logisticsInterface;
              v.addItems.maxEfficiency = item.maxEfficiency;
              v.addItems.minEfficiency = item.minEfficiency;
              v.addItems.status = item.status;
              v.addItems.hasTrackingNumber = item.hasTrackingNumber;
            }
          });
        }
      }
    },
    // 保存按钮
    relatedLogisticsBtn() {
      let v = this;
      let query = [];
      if (v.tableData.length > 0) {
        v.tableData.map((item) => {
          query.push({
            carrierId: item.carrierId,
            shippingMethodId: item.shippingMethodId,
            ymsLogisServiceId: v.ymsLogisServiceId,
            merchantType: Number(v.merchantType)
          });
        });
        if (v.merchantType === '3' && v.tableData.length > 1) {
          v.$Message.warning(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000295')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005222')}`);
          return false;
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005225'));
        return false;
      }
      v.axios.post(api.post_ymsLogisServiceMapping_save, query, {loading: true}).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          v.relatedLogisticsModal = false;
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.$emit('updateData', true);
        }
      });
    },
    // 添加关联
    addAssociationsBtn() {
      if (this.shippingMethodModel.length > 0 && this.shippingMethodModel.length === 2) {
        this.tableData.push(this.addItems);
        this.shippingMethodModel = [];
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005226'));
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005227'));
      }
    },
    // 监听弹窗
    relatedLogisticsModalChange(value) {
      if (!value) {
        this.shippingMethodModel = [];
        this.ymsLogisServiceId = null;
        this.tableData = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.title_box {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 16px;

  .name {
    font-size: 17px;
    font-weight: bold;
    display: inline-block;
    width: 380px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: break-word;
    word-break: break-all;
  }
}

</style>
